import React, { useEffect, useState, useContext, useRef } from 'react'
import axios from "axios";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import { GlobalContext } from '../contexts/GlobalContext'
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Fancybox from './Fancybox';
import Fab from '@mui/material/Fab';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { IconPlus, IconMinus, IconSend, IconSearch, IconX, IconChevronUp, IconChevronDown } from '@tabler/icons-react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import InputLabel from '@mui/material/InputLabel';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import { format, formatDistance, parse } from 'date-fns'
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Pusher from 'pusher-js';
import { AudioRecorder } from 'react-audio-voice-recorder';
import './Audio.css';
import CardMedia from '@mui/material/CardMedia';
import Chip from '@mui/material/Chip';
import ReactAudioPlayer from 'react-audio-player';
import { useNavigate } from "react-router-dom";
import LoadingComponent from './LoadingComponent';


function Chatter(props) {
    const FloatDetails = props.FloatDetails;

    const [id, setId] = useState(props.id);
    const { url, cdn, wsHost, wsKey, wsPort, phone, user, contact,  customer, token, portal } = useContext(GlobalContext);
    const [loading, setLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
 
    const [channel, setChannel] = useState([]);
    const [messages, setMessages] = useState([]);
    const [newMessages, setNewMessages] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    const [currentPage, setCurrentPage] = useState(0);
    const [lastPage, setLastPage] = useState(null);
    const [perPage, setPerPage] = useState(30);
    const scrollRef = useRef(null);
    const virtuosoRef = useRef(null);
    const listRef = useRef(null);
    const didInitialScrollRef = useRef(false);
    const currentPageRef = useRef(0);
    const lastPageRef = useRef(null);
    const fetchingRef = useRef(false);
    const messagesRef = useRef([]);
    const initialTopRef = useRef(null);

    const FIRST_ITEM_INDEX_INIT = 100000;
    const [firstItemIndex, setFirstItemIndex] = useState(FIRST_ITEM_INDEX_INIT);
    const firstItemIndexRef = useRef(FIRST_ITEM_INDEX_INIT);
    const updateFirstItemIndex = (updater) => {
        firstItemIndexRef.current = typeof updater === 'function' ? updater(firstItemIndexRef.current) : updater;
        setFirstItemIndex(firstItemIndexRef.current);
    };

    const [searchOpen, setSearchOpen] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [searchMatches, setSearchMatches] = useState([]);
    const [activeMatchIndex, setActiveMatchIndex] = useState(0);
    const [searchLoading, setSearchLoading] = useState(false);
    const [flashId, setFlashId] = useState(null);
    const [pendingScrollId, setPendingScrollId] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        const client = new Pusher(wsKey, {
			wsHost: wsHost,
            forceTLS: false,
            encrypted: true,
            disableStats: true,
            enabledTransports: ['ws', 'wss'],
            // authEndpoint: url + 'api/broadcasting/auth',
            // auth: {
            //     headers: {
            //         'Accept': 'application/json',
            //         'Content-Type': 'application/json',
            //         'Authorization': "Bearer " + token
            //     }
            // }
		})
        // const channel = client.subscribe('customers.' + customer);
        const channel = client.subscribe('chat.' + id); // create channels

        channel.bind("chat-event", function(data) {
            var msg = JSON.parse(data.message);
            setNewMessages(true);
            setMessages((prev) => {
                const next = [...prev, ...msg];
                messagesRef.current = next;
                return next;
            });
        });


        channel.bind("pusher:subscription_succeded", function() {
            console.log("pusher:subscription_succeded");
        });

        channel.bind("pusher:subscription_error", function(error) {
            console.log("pusher:subscription_succeded", error);
        });

        setChannel([]);
        setMessages([]);
        messagesRef.current = [];
        setHasMore(true);
        setCurrentPage(0);
        setLastPage(null);
        currentPageRef.current = 0;
        lastPageRef.current = null;
        fetchingRef.current = false;
        firstItemIndexRef.current = FIRST_ITEM_INDEX_INIT;
        setFirstItemIndex(FIRST_ITEM_INDEX_INIT);
        initialTopRef.current = null;
        didInitialScrollRef.current = false;
        setSearchOpen(false);
        setSearchInput('');
        setSearchQuery('');
        setSearchMatches([]);
        setActiveMatchIndex(0);
        fetchData();
    }, [ id ]);


    const fetchData = async () => {
        if (fetchingRef.current) return;
        if (lastPageRef.current !== null && currentPageRef.current >= lastPageRef.current) return;
        fetchingRef.current = true;
        setIsLoading(true);
        const page = currentPageRef.current + 1;
        try {
            const response = await axios.post(url + 'api/chat/channel/data?page=' + page, {
                customer: user,
                contact: 0,
                phone: phone,
                channel: id,
                portal: "admin",
                creator: 1,
                order: "desc",
            }, { headers: { Authorization: `Bearer ${token}` } });

            setChannel(response.data.channel);
            const incoming = response.data.messages.data || [];
            const prev = messagesRef.current;
            const merged = mergeMessages(prev, incoming);
            if (prev.length > 0) {
                const firstPrevId = prev[0].id;
                const prependedCount = merged.findIndex((m) => m.id === firstPrevId);
                if (prependedCount > 0) {
                    firstItemIndexRef.current -= prependedCount;
                    setFirstItemIndex(firstItemIndexRef.current);
                }
            } else {
                initialTopRef.current = merged.length - 1;
            }
            messagesRef.current = merged;
            setMessages(merged);
            const cp = parseInt(response.data.messages.current_page);
            const lp = parseInt(response.data.messages.last_page);
            currentPageRef.current = cp;
            lastPageRef.current = lp;
            setCurrentPage(cp);
            setLastPage(lp);
            if (response.data.messages.per_page) {
                setPerPage(parseInt(response.data.messages.per_page));
            }
            if (cp >= lp) setHasMore(false);
            setLoading(false);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
            fetchingRef.current = false;
        }
    }

    const mergeMessages = (prev, incoming) => {
        if (!incoming || !incoming.length) return prev;
        const map = new Map();
        for (const m of prev) map.set(m.id, m);
        for (const m of incoming) map.set(m.id, m);
        return Array.from(map.values()).sort((a, b) => {
            const t = new Date(a.created_at) - new Date(b.created_at);
            if (t !== 0) return t;
            return a.id - b.id;
        });
    }

    const fetchPage = async (pageNum) => {
        const response = await axios.post(url + 'api/chat/channel/data?page=' + pageNum, {
            customer: user,
            contact: 0,
            phone: phone,
            channel: id,
            portal: "admin",
            creator: 1,
            order: "desc",
        }, { headers: { Authorization: `Bearer ${token}` } });
        return response.data.messages;
    }



    const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    const highlightText = (text, query) => {
        if (!query || !text) return text;
        const parts = String(text).split(new RegExp(`(${escapeRegExp(query)})`, 'gi'));
        return parts.map((part, i) =>
            part.toLowerCase() === query.toLowerCase()
                ? <mark key={i} style={{ backgroundColor: '#ffeb3b', padding: 0 }}>{part}</mark>
                : <React.Fragment key={i}>{part}</React.Fragment>
        );
    }

    useEffect(() => {
        const t = setTimeout(() => {
            setSearchQuery(searchInput.trim());
        }, 250);
        return () => clearTimeout(t);
    }, [ searchInput ]);

    useEffect(() => {
        if (!searchQuery || searchQuery.length < 2) {
            setSearchMatches([]);
            setActiveMatchIndex(0);
            return;
        }
        let cancelled = false;
        setSearchLoading(true);
        axios.post(url + 'api/chat/channel/search', {
            channel: id,
            q: searchQuery,
            per_page: perPage,
            order: "desc",
        }, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => {
            if (cancelled) return;
            const matches = response.data.matches || [];
            setSearchMatches(matches);
            setActiveMatchIndex(0);
            if (matches.length) {
                const target = matches[0];
                const inRef = messagesRef.current.findIndex((m) => m.id === target.id);
                if (inRef === -1) {
                    loadUntilMessage(target.id, target.page).then(() => {
                        if (cancelled) return;
                        setPendingScrollId(target.id);
                        setSearchLoading(false);
                    });
                } else {
                    setPendingScrollId(target.id);
                    setSearchLoading(false);
                }
            } else {
                setSearchLoading(false);
            }
        })
        .catch((err) => {
            if (cancelled) return;
            console.log(err);
            setSearchLoading(false);
        });
        return () => { cancelled = true; };
    }, [ searchQuery, id, perPage ]);

    const loadUntilMessage = async (targetId, targetPage) => {
        const hasTarget = () => messagesRef.current.findIndex((m) => m.id === targetId) !== -1;
        let safety = 30;
        while (!hasTarget() && safety-- > 0) {
            const nextPage = currentPageRef.current + 1;
            try {
                const page = await fetchPage(nextPage);
                const incoming = page.data || [];
                const prev = messagesRef.current;
                const merged = mergeMessages(prev, incoming);
                if (prev.length > 0) {
                    const firstPrevId = prev[0].id;
                    const prependedCount = merged.findIndex((m) => m.id === firstPrevId);
                    if (prependedCount > 0) {
                        firstItemIndexRef.current -= prependedCount;
                        setFirstItemIndex(firstItemIndexRef.current);
                    }
                } else {
                    initialTopRef.current = merged.length - 1;
                }
                messagesRef.current = merged;
                setMessages(merged);
                const cp = parseInt(page.current_page);
                const lp = parseInt(page.last_page);
                currentPageRef.current = cp;
                lastPageRef.current = lp;
                setCurrentPage(cp);
                setLastPage(lp);
                if (cp >= lp) setHasMore(false);
                await new Promise((r) => setTimeout(r, 50));
                if (targetPage && cp >= targetPage && hasTarget()) break;
            } catch (e) {
                console.log(e);
                break;
            }
        }
    }

    const jumpToMatch = async (index) => {
        if (index < 0 || index >= searchMatches.length) return;
        setActiveMatchIndex(index);
        const target = searchMatches[index];
        if (messagesRef.current.findIndex((m) => m.id === target.id) === -1) {
            setSearchLoading(true);
            try {
                await loadUntilMessage(target.id, target.page);
            } finally {
                setSearchLoading(false);
            }
        }
        setPendingScrollId(target.id);
    }


    const handleListScroll = (e) => {
        const el = e.currentTarget;
        if (!hasMore || fetchingRef.current) return;
        if (pendingScrollId) return;
        if (el.scrollTop < el.clientHeight * 0.3) {
            const prevHeight = el.scrollHeight;
            const prevTop = el.scrollTop;
            fetchData().then(() => {
                requestAnimationFrame(() => {
                    if (listRef.current) {
                        const delta = listRef.current.scrollHeight - prevHeight;
                        listRef.current.scrollTop = prevTop + delta;
                    }
                });
            });
        }
    };

    useEffect(() => {
        if (didInitialScrollRef.current) return;
        if (!messages.length || !listRef.current) return;
        didInitialScrollRef.current = true;
        requestAnimationFrame(() => {
            if (listRef.current) {
                listRef.current.scrollTop = listRef.current.scrollHeight;
            }
        });
    }, [ messages ]);

    useEffect(() => {
        if (!pendingScrollId) return;
        const targetId = pendingScrollId;
        const tryScroll = (attempt) => {
            const el = document.querySelector(`[data-message-id="${targetId}"]`);
            const container = listRef.current;
            if (!el || !container) {
                if (attempt < 20) setTimeout(() => tryScroll(attempt + 1), 100);
                return;
            }
            const containerRect = container.getBoundingClientRect();
            const elRect = el.getBoundingClientRect();
            const desiredTop = container.scrollTop + (elRect.top - containerRect.top) - (container.clientHeight / 2) + (elRect.height / 2);
            container.scrollTo({ top: Math.max(0, desiredTop), behavior: 'auto' });
            setFlashId(targetId);
            setTimeout(() => setFlashId(null), 1500);
            // keep the guard alive until the smooth scroll settles
            setTimeout(() => setPendingScrollId(null), 800);
        };
        setTimeout(() => tryScroll(0), 50);
    }, [ pendingScrollId, messages ]);

    const toggleSearch = () => {
        if (searchOpen) {
            setSearchOpen(false);
            setSearchInput('');
            setSearchQuery('');
            setSearchMatches([]);
        } else {
            setSearchOpen(true);
        }
    }

    function stringToColor(string) {
        let hash = 0;
        let i;
      
        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
          hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }
      
        let color = '#';
      
        for (i = 0; i < 3; i += 1) {
          const value = (hash >> (i * 8)) & 0xff;
          color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */
      
        return color;
    }
     
    function stringAvatar(name) {
        var split = name.split(' ');
        return {
            sx: {
            bgcolor: stringToColor(name),
            width: 26,
            height : 26,
            fontSize: 12
            },
            children: `${split[0][0]}${split[1] ? split[1][0] : ''}`,
        };
    }

    const NewOrder = (prop) => {
        const [open, setOpen] = useState(false)
        const [form, setForm] = useState([]);
        const [formProducts, setFormProducts] = useState([]);
        const [tempData, setTempData] = useState([]);

        const handleOpen = () => {
            setOpen(true);
        }

        const handleClose = () => {
            setOpen(false);
        }

        const fetchData = () => {
            axios.post( url + 'api/suppliers/chat/forms/data', {
                customer: user,
                contact: 0,
                phone: phone,
                id: id,
                form: prop.form_id
            }, { headers: { Authorization: `Bearer ${token}` }})
            .then(function (response) {
                setForm(response.data.form);
                setFormProducts(response.data.products);
                handleOpen();
            })
            .catch(function (error) {
                console.log(error);
            });
        }

        
        const handleSubmit = (event) => {
            event.preventDefault();
           
            axios.post( url + 'api/buyers/chat/order', {
                customer: user,
                contact: 0,
                phone: phone,
                form: prop.form_id,
                channel: channel.name,
                buyer: channel.buyer,
                seller: channel.seller,
                creator: 1,
                items: tempData
            }, { headers: { Authorization: `Bearer ${token}` }})
            .then(function (response) {
                
            })
            .catch(function (error) {
                console.log(error);
            });
        }

        const updateData = (id, size, qty) => {
            setTempData(prevData => {
              const updatedData = prevData.map(item => {
                if (item.id === id && item.size === size) {
                  return {
                    ...item,
                    qty: qty
                  };
                } else {
                  return item;
                }
              });
          
              const existingItem = prevData.find(item => item.id === id && item.size === size);
          
              if (!existingItem) {
                updatedData.push({ id, size, qty });
              }
          
              return updatedData;
            });
        };

        const ProductQty = (prop) => {
            
            const [qty, setQty] = useState(() => {
                const existingItem = prop.tempData.find(item => item.id === prop.id && item.size === prop.size);
                return existingItem ? existingItem.qty : 0;
            });

            const updateQty = (mode) => {
                var newQty = parseFloat(qty);
                if (mode == "+") {
                  newQty = newQty + 1;
                } else if (mode == "-") {
                  newQty = newQty - 1;
                  if (newQty < 0) {
                    newQty = 0;
                  }
                }
                setQty(newQty);
                prop.updateData(prop.id, prop.size, newQty);
            };
              
            return (
                <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 2, marginTop: 2 }}>
                    <Button style={{maxWidth: '30px', maxHeight: '30px', minWidth: '30px', minHeight: '30px'}} variant="outlined" size="small" onClick={event => { updateQty("-"); }}>
                        <IconMinus size={10} />
                    </Button>
                    <TextField id="outlined-basic" label={prop.label} variant="outlined" size="small" value={qty} onChange={(e) => setQty(e.target.value)} />
                    <Button style={{maxWidth: '30px', maxHeight: '30px', minWidth: '30px', minHeight: '30px'}} variant="outlined" size="small" onClick={event => { updateQty("+"); }}>
                        <IconPlus size={10} />
                    </Button>
                </Box>
            )

        }

        const Product = (prop) => {
            var ts = [];
            if(prop.data.sizes) {
                prop.data.sizes.name.split(",").forEach(function(row) {
                    ts.push({ name: row, qty: 0 });
                })
            }
            const [product_sizes, setProductSizes] = useState(ts)
            var images = JSON.parse(prop.data.image);
            return (
                <Paper sx={{ border: 1, borderColor: 'divider', cursor: 'pointer', width: '100%', maxWidth: '100%', textAlign: 'center', mt: 4 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <CardMedia data-fancybox="order_form" href={ cdn + 'catalog/' + images[0].file } sx={{ height: 300, width: "100%", borderRadius: 1  }} image={cdn + 'catalog/' + images[0].file}/>
                        <Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column', p: 2 }}>
                            <Typography display="block" gutterBottom>{prop.data.name.toUpperCase()}</Typography>
                            {prop.data.sizes &&
                                <Chip label="Sizes Available" color="primary" variant="outlined" size="small" sx={{ marginTop: "3px", }} />
                            }
                            {prop.data.sizes ?
                                <>
                                    {product_sizes.map((row, index) => (
                                        <ProductQty key={index} label={row.name.toUpperCase() } id={prop.data.id} size={row.name.toUpperCase() } tempData={tempData} updateData={updateData} />
                                    ))}
                                </>                                
                                :
                                <ProductQty label="Qty" id={prop.data.id} size={ null } tempData={tempData} updateData={updateData} />
                            }
                        </Box>
                    </Box>
                </Paper>
            )
        }

        return (
            <>
                <Button variant="contained" onClick={fetchData}>Place Order</Button>
                <Dialog onClose={handleClose} open={open}>
                    <DialogTitle>Place Order</DialogTitle>
                    <DialogContent sx={{ width: '80vw', maxWidth: '300px' }}>
                        <Fancybox options={{ Carousel: { infinite: false } }}>
                            <form onSubmit={handleSubmit}>
                                {formProducts.map((row, index) => (
                                    <Product key={row.id} data={row} index={index}></Product>
                                ))}
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 2 }}>
                                    <Button type="submit" variant="contained">Place</Button>
                                </Box>
                            </form>
                        </Fancybox>
                    </DialogContent>
                </Dialog>
            </>
        )
    }

    const Images = (prop) => {
        const timestamp = Date.now();
        const randomString = Math.random().toString(36).substring(2, 15);
        const gallery_name = `${timestamp}_${randomString}`;
        const commonImageExtensions = ["jpg", "jpeg", "png", "gif", "svg", "webp", "bmp", "tiff", "tif", "ico", "jxr"];
        const documentFormats = ['pdf', 'doc', 'docx', 'txt', 'rtf', 'odt', 'html', 'xml', 'csv', 'json', 'xls', 'xlsx', 'ppt', 'pptx', 'odp', 'epub'];
        const openLink = (link) => {
            window.open(link, '_blank').focus();
        }
        if(prop.filesArray?.length == 1) {
            const ext = prop.filesArray[0]?.file?.split('.')?.pop().toLowerCase();
            const isImage = commonImageExtensions.includes(ext)
            const isDoc = documentFormats.includes(ext)
            return (
            <Box>
                {isImage && 
                <Fancybox options={{ Carousel: { infinite: false } }}>
                    <img data-fancybox={gallery_name} href={ cdn + "chat/" + prop.filesArray[0]?.file } src={ cdn + "chat/" + prop.filesArray[0]?.file } style={{ width: 200, height: 'auto', borderRadius: 3, verticalAlign: 'middle' }} />
                </Fancybox>}
                {isDoc &&
                    <Box sx={{ width: '150px', height: "150px", display: 'flex', justifyContent:"center", alignItems:"center", flexDirection: 'column', gap: 2, p: 2, border: 3, borderColor: 'divider', borderRadius: "10px" }} >
                        <Box sx={{ borderRadius: 2, background: "#fff", height: "100px", width: "100px", overflow: "hidden", position: "relative", display: 'flex', justifyContent: 'center', alignItems: 'center', }} 
                            href={ cdn + "chat/" + prop.filesArray[0]?.file}
                            onClick={() => openLink(cdn + "chat/" + prop.filesArray[0]?.file)}
                            >
                                <Box >
                                <Typography sx={{textAlign: "center"}}>{ext.toUpperCase()}</Typography> 
                                <Typography sx={{fontSize:"75%"}}>{"Click here to open"}</Typography>
                                </Box>
                                
                            </Box>                        
                    </Box>
                }
            </Box>
            )
        } else if(prop.filesArray?.length > 1) {
            return (
            <Fancybox options={{ Carousel: { infinite: false } }}>
                <Box sx={{ position: 'relative', display: 'inline-block', width: 200, cursor: 'pointer' }}>
                    <img src={ cdn + "chat/" + prop.filesArray[0]?.file } style={{ width: 200, height: 'auto', borderRadius: 3, verticalAlign: 'middle' }} />
                    <Box data-fancybox={gallery_name} href={ cdn + "chat/" + prop.filesArray[0]?.file } sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        }}>
                             <Chip label={ "+" + (Object.keys(prop.filesArray).length - 1) + " images" } sx={{ zIndex: 2, background: "#fff" }} />
                    </Box>
                    {prop.filesArray?.map((fileObj, index) => {
                        if(index != 0){
                            return <img key={index} data-fancybox={gallery_name} href={ cdn + "chat/" + fileObj?.file } src={ cdn + "chat/" + fileObj?.file } style={{ display: 'none' }} />
                        }
                    }
                    )}
                </Box>
            </Fancybox>)
        }
    }

    const Message = (prop) => {
        var data = JSON.parse(prop.data.data);
        const query = prop.highlightQuery;
        const isFlash = prop.isFlash;

        return (
            <Box data-message-id={prop.data.id} sx={{ width: '100%', px: 3, py: 3, transition: 'background-color 600ms ease', backgroundColor: isFlash ? 'rgba(255, 235, 59, 0.25)' : 'transparent' }}>
                <Stack sx={{ width: '100%'}} direction={ prop.data.creator == 1 ? 'row-reverse' : 'row'} justifyContent={ prop.data.creator == 1 ? 'flex-end' : 'flex-start'} spacing={2} alignItems="start">
                    <Box sx={{ mt: 1 }}>
                        { prop.data.creator_details ?
                            <Avatar {...stringAvatar(prop.data.creator_details.name)} />
                            :
                            null
                        }
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                        <Box>
                            <Paper sx={{ p: 2, mb:1, background: (data.type == "audio" ? '#fff' : ''), color: (data.type == "audio" ? '#000' : '') }}>
                                    { prop.data.creator_details ?
                                        <Typography variant="caption" component="div" sx={{ mb:1 }}>{prop.data.details.name} | {prop.data.creator_details.name}</Typography>
                                        :
                                        null
                                    }
                                    { data.type == "text" &&
                                        <Typography variant="body" component="p">{highlightText(data.message, query)}</Typography>
                                    }

                                    { data.type == "form" &&
                                        <>
                                            <Typography variant="body" component="p" sx={{ mb:1 }}>New Order Request Sent</Typography>
                                            <Typography variant="caption" component="div">{highlightText(data.form_name, query)}</Typography>
                                        </>
                                    }

                                    { data.type == "form_order" &&
                                        <>
                                            <Typography variant="body" component="p" sx={{ mb:1 }}>New Form Order</Typography>
                                            <Typography variant="caption" component="div" sx={{ mb:1 }}>{highlightText(data.form_name, query)}</Typography>
                                            <Button variant="contained" onClick={event => { return navigate("/order/" + data.voucher_id) }}>View Order</Button>
                                        </>
                                    }

                                    { data.type == "catalog_order" &&
                                        <>
                                            <Typography variant="body" component="p" sx={{ mb:1 }}>New Catalog Order</Typography>
                                            <Button variant="contained" onClick={event => { return navigate("/order/" + data.voucher_id) }}>View Order</Button>
                                        </>
                                    }

                                    { data.type == "customorder" &&
                                        <>
                                            <Typography variant="body" component="p" sx={{ mb:1 }}>New Custom Order</Typography>
                                            <Button variant="contained" onClick={event => { return navigate("/order/" + data.id) }}>View Order</Button>
                                        </>
                                    }

                                    { data.type == "attachments" &&    
                                        <Images filesArray={data.files} />
                                    }

                                    { data.type == "audio" &&
                                        <ReactAudioPlayer src={ cdn + "audio/" + data.file } controls />
                                        
                                    }
                                </Paper>
                            <Typography variant="caption" component="div">{formatDistance(new Date(prop.data.created_at), new Date(), { addSuffix: true })}</Typography>
                        </Box>
                    </Box>
                </Stack>
            </Box>
        )
    }

    const SendOrderForm = (prop) => {
        const [open, setOpen] = useState(false)
        const [form, setForm] = useState([])
        const [forms, setForms] = useState([])

        const handleOpen = () => {
            setOpen(true);
            prop.toggleDrawer(false)
        }

        const handleClose = () => {
            setOpen(false);
        }

        const handleSubmit = (event) => {
            event.preventDefault();
            axios.post( url + 'api/chat/message', {
                customer: user,
                contact: 0,
                phone: phone,
                creator: 1,
                channel: channel.name,
                buyer: channel.buyer,
                seller: channel.seller,
                data: JSON.stringify({ type: "form", form_id: form.id, form_name: form.name }),
            }, { headers: { Authorization: `Bearer ${token}` }})
            .then(function (response) {
                handleClose()
                // setMessages((prev) => [...prev, ...response.data.messages]);
            })
            .catch(function (error) {
                console.log(error);
            });
        }

        const fetchForms = (query) => {
            if (query.length) {
                axios.post( url + 'api/suppliers/chat/forms/search', {
                    customer: user,
                    contact: 0,
                    phone: phone,
                    query: query
                }, { headers: { Authorization: `Bearer ${token}` }})
                .then(function (response) {
                    setForms(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        }

        return (
            <>
                <ListItemText primary="Order Form"  onClick={handleOpen} />
                <Dialog onClose={handleClose} open={open}>
                    <DialogTitle>Order Form</DialogTitle>
                    <DialogContent sx={{ width: '80vw', maxWidth: '500px' }}>
                        <form onSubmit={handleSubmit}>
                            <InputLabel shrink>Name</InputLabel>
                            <Autocomplete sx={{ mb: 2 }}
                                options={ forms }
                                getOptionLabel={(option) => option.name ? `${option.name}${option.blacklist ? ' ●' : ''}` : ''}
                                dataSource={forms}
                                onInputChange={(event, newInputValue) => { fetchForms(newInputValue) }}
                                value={form}
                                onChange={(event, newValue) => {
                                    setForm(newValue)
                                }}
                                renderInput={(params) => <TextField {...params} required={true} />}
                            />

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 2 }}>
                                <Button type="submit" variant="contained">Send</Button>
                            </Box>
                        </form>
                    </DialogContent>
                </Dialog>
            </>
        );
    }

    const ImageUploader = (prop) => {
        const {uploadedItem} = prop
        const inputFile = useRef(null) 
        const [open, setOpen] = useState(false)
        const handleOpen = () => {
            prop.toggleDrawer(false)
            inputFile.current.click()
        }

        const handleSubmit = async (event) => {
            event.preventDefault();
            const files = inputFile.current.files;
            const formData = new FormData();
            formData.append("customer", user);
            formData.append("contact", "0");
            formData.append("phone", phone);
            formData.append("creator", 1);
            formData.append("channel", channel.name);
            formData.append("buyer", channel.buyer);
            formData.append("seller", channel.seller);
            if(uploadedItem === "images"){
                for (let i = 0; i < files.length; i++) {
                if(files[i].type.includes("image")) {
                    formData.append('files[]', files[i]);
                }
            }}
            if(uploadedItem === "file"){
                for (let i = 0; i < files.length; i++) {
                    formData.append('files[]', files[i]);
            }}
            try {
                // Send a POST request to the Laravel endpoint with the FormData object
                if(formData.has('files[]')){
                const response = await axios.post( url + 'api/chat/message', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${token}`
                    }
                });}
                inputFile.current.value = '';
            } catch (error) {
                // Handle errors as needed
                console.error(error);
            }
        }

        return (
            <>
                <ListItemText primary={uploadedItem == "images" ? "Image" : "File"}  onClick={handleOpen} />
                { uploadedItem === "images" && <input type="file" accept="image/*" id="files" ref={inputFile} style={{display: 'none'}} multiple onChange={handleSubmit} />}
                { uploadedItem === "file" && <input type="file" accept="application/pdf" id="files" ref={inputFile} style={{display: 'none'}} onChange={handleSubmit} />}
            </>
        );
    }

    const ChatBar = () => {
        const [open, setOpen] = React.useState(false);
        const [message, setMessage] = React.useState("");
        const textFieldRef = useRef(null);
        const [sending, setSending] = useState(false);

        const toggleDrawer = (newOpen) => () => {
            setOpen(newOpen);
        }; 

        function preventDuplicateSend(){
            setSending(true);
        }
     
        const sendMessage = (event) => {
            if (message == ""){
                return;
            }
            preventDuplicateSend();
            event.preventDefault();
            axios.post( url + 'api/chat/message', {
                customer: user,
                contact: 0,
                phone: phone,
                creator: 1,
                channel: channel.name,
                buyer: channel.buyer,
                seller: channel.seller,
                data: JSON.stringify({ type: "text", message: message }),
            }, { headers: { Authorization: `Bearer ${token}` }})
            .then(function (response) {
                setMessage('');
                // textFieldRef.current.focus()
                // setMessages((prev) => [...prev, ...response.data.messages]);
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(() => setSending(false));
        };

        const sendAudio = (blob) => {
            const timestamp = Date.now();
            const randomString = Math.random().toString(36).substring(2, 15);
            const filename = `${timestamp}_${randomString}.wav`;

            const formData = new FormData();
            formData.append('audio', blob, filename);
            formData.append('customer', user);
            formData.append('contact', "");
            formData.append('phone', phone);
            formData.append('creator', 1);
            formData.append('channel', channel.name);
            formData.append('buyer', channel.buyer);
            formData.append('seller', channel.seller);
            formData.append('filename', filename);
            formData.append('data', JSON.stringify({ type: "audio", file: filename }));

            axios.post( url + 'api/chat/message', formData, { headers: { Authorization: `Bearer ${token}` }})
            .then(function (response) {
                setMessage('');
                // setMessages((prev) => [...prev, ...response.data.messages]);
            })
            .catch(function (error) {
                console.log(error);
            });
        };

        const [isTextFieldFocused, setIsTextFieldFocused] = useState(false);

        const handleTextFieldFocus = () => {
            setIsTextFieldFocused(true);
        };

        const handleTextFieldBlur = () => {
            setIsTextFieldFocused(false);
        };

        const addAudioElement = (blob) => {
            const url = URL.createObjectURL(blob);
            const audio = document.createElement("audio");
            audio.src = url;
            audio.controls = true;
            document.body.appendChild(audio);
          };

        

        return (
            <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, px: 1, py: 2, zIndex: 99 }} elevation={3}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <>
                        <div onClick={toggleDrawer(true)} sx={{ p: 0, cursor: 'pointer'}}><IconPlus /></div>
                        <TextField id="outlined-basic" autoComplete="off" variant="outlined" sx={{ flexGrow: 1}} 
                                value={message}
                                inputRef={textFieldRef}
                                onFocus={handleTextFieldFocus}
                                onBlur={handleTextFieldBlur}
                                multiline
                                rows={1}
                                onChange={event => {
                                    const { value } = event.target;
                                    setMessage(value);
                                }}/>
                        {
                            sending 
                            ? <><CircularProgress /></>
                            : <div onClick={sendMessage} style={{padding: 0, cursor: 'pointer', marginRight: '10px', marginLeft: '10px'}}><IconSend /></div>
                        }
                    </>
                    {!isTextFieldFocused && message.trim() == '' && <AudioRecorder onRecordingComplete={(blob) => sendAudio(blob)} /> }

                </Box>
                
                <SwipeableDrawer anchor="bottom" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
                    <List component="nav" aria-label="main mailbox folders" sx={{ paddingBottom: 'calc(env(safe-area-inset-bottom) + 10px)' }}>
                        <ListItemButton>
                            <ImageUploader uploadedItem={"images"} toggleDrawer={ toggleDrawer() } />
                        </ListItemButton>
                        <ListItemButton>
                            <ImageUploader uploadedItem={"file"} toggleDrawer={ toggleDrawer() } />
                        </ListItemButton>
                    </List>
                </SwipeableDrawer>
            </Paper>
        )
    }
   
    const scrollBottom = () => {
        setNewMessages(false);
        window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: "smooth"
        });
    };

    const SearchBar = () => (
        <Box sx={{ flexShrink: 0, zIndex: 9, background: '#fff', borderBottom: 1, borderColor: 'divider', px: 2, py: 1.5, minHeight: 52, display: 'flex', alignItems: 'center', gap: 1 }}>
            {searchOpen ? (
                <>
                    <TextField
                        autoFocus
                        size="small"
                        fullWidth
                        placeholder="Search messages..."
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                if (e.shiftKey) jumpToMatch(activeMatchIndex - 1);
                                else jumpToMatch(activeMatchIndex + 1);
                            } else if (e.key === 'Escape') {
                                toggleSearch();
                            }
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <IconSearch size={18} />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Typography variant="caption" sx={{ whiteSpace: 'nowrap', minWidth: 90, textAlign: 'center' }}>
                        {searchLoading
                            ? 'Searching...'
                            : searchMatches.length
                                ? `${activeMatchIndex + 1} of ${searchMatches.length}`
                                : (searchQuery ? '0 of 0' : '')}
                    </Typography>
                    <IconButton size="small" disabled={searchLoading || !searchMatches.length || activeMatchIndex >= searchMatches.length - 1} onClick={() => jumpToMatch(activeMatchIndex + 1)} title="Previous (older)">
                        <IconChevronUp size={18} />
                    </IconButton>
                    <IconButton size="small" disabled={searchLoading || !searchMatches.length || activeMatchIndex <= 0} onClick={() => jumpToMatch(activeMatchIndex - 1)} title="Next (newer)">
                        <IconChevronDown size={18} />
                    </IconButton>
                    <IconButton size="small" onClick={toggleSearch} title="Close">
                        <IconX size={18} />
                    </IconButton>
                </>
            ) : (
                <Box sx={{ ml: 'auto' }}>
                    <IconButton size="small" onClick={toggleSearch} title="Search messages">
                        <IconSearch size={20} />
                    </IconButton>
                </Box>
            )}
        </Box>
    );

    return (
        <Box ref={scrollRef} sx={{ position: 'fixed', top: { xs: 56, sm: 64 }, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden', background: '#f5f7fa' }}>
        {  loading ?
            <LoadingComponent loading={loading} />
            :
            <>
                {FloatDetails ?
                    <FloatDetails />
                    :
                    <></>
                }
                <SearchBar />
                <Box
                    ref={listRef}
                    onScroll={handleListScroll}
                    sx={{ flexGrow: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}
                >
                    {hasMore
                        ? <p style={{ textAlign: 'center', fontSize: '14px', margin: '8px 0' }}>Loading...</p>
                        : <p style={{ textAlign: 'center', fontSize: '14px', margin: '8px 0' }}>You have reached end of the list</p>}
                    {messages.map((row) => (
                        <Message
                            key={row.id}
                            data={row}
                            highlightQuery={searchQuery}
                            isFlash={flashId === row.id}
                        />
                    ))}
                    <Box sx={{ height: '70px' }} />
                </Box>
                <ChatBar />
            </>
        }
        </Box>
    );
}

export default Chatter;
